import { iReviewFormValues } from '@services/ReviewService';
import { Field, getIn, useFormikContext } from 'formik';
import { ReactElement, useState } from 'react';
import gridStyles from '@pages/forms/Grid.module.scss';
import { AddressFieldAccessible, ContactInputWithExperian, DateInput, EmailFieldWithExperian, LicenceFieldAccessible, Modal, ReviewAddressModal, TextInput, TileRadioAccessible } from '@components';
import { tile } from '@interfaces/interfaces';
import { reviewInfoDisplayObject } from '@services/FormFieldConfig';
import { FormType } from '@constants/forms';
import styles from './ReviewStep9.module.scss';

function ReviewStep9(): ReactElement {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { values }: { values: iReviewFormValues; } = useFormikContext<iReviewFormValues>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [isDisabled, setDisabled] = useState(false);
    const pageFields = reviewInfoDisplayObject.pages.FineholderContactInformation.fields;
    const pageTitles = reviewInfoDisplayObject.pages.FineholderContactInformation;
    const [modal, setModal] = useState({
      show: false,
      title: '',
      content: <></>,
      contentClass: '',
    });
    const YesValue = (): ReactElement => (
      <>
        <div>Yes</div>
      </>
    );
    const NoValue = (): ReactElement => (
      <>
        <div>No</div>
      </>
    );

    const differentToPostal: tile[] = [
      {
        body: <YesValue />,
        value: 'true',
      },
      {
        body: <NoValue />,
        value: 'false',
      },
    ];
    return (
      <>
        <div className={gridStyles.form}>
          <span className="vfH2">{pageTitles.pageTitle}</span>
          <p>Please enter the details of the <b>person who received the fine</b></p>
          <p>All fields are required unless specified otherwise</p>
          <Field component={TextInput} name={pageFields.givenName.formikName} title={pageFields.givenName.title} isMandatory />
          <Field component={TextInput} name={pageFields.familyName.formikName} title={pageFields.familyName.title} isMandatory />
          <Field
            name={pageFields.dateOfBirth.formikName}
            component={DateInput}
            minDate={new Date(1900, 1, 1)}
            title={pageFields.dateOfBirth.title}
            isMandatory
            maxDate={new Date()}
            isDisabled={false}
          />
          <LicenceFieldAccessible
            title={pageFields.driverLicence.title}
            name={pageFields.driverLicence.formikName}
            nameStateOfIssue={pageFields.licenceState.formikName}
            nameCountryOfIssue={pageFields.countryOfIssue.formikName}
            nameNoDriverLicence={pageFields.noDriverLicence.formikName}
            noDriverLicenceTitle={pageFields.noDriverLicence.title}
            isMandatory
          />
          <AddressFieldAccessible name={pageFields.postalAddress.formikName} title={pageFields.postalAddress.title} manualAddressText="Enter address manually" isMandatory />
          <Field
            component={TileRadioAccessible}
            name={pageFields.isAddressSameAsPostal.formikName}
            title={pageFields.isAddressSameAsPostal.title}
            tileData={differentToPostal}
            tileContainer
            isMandatory
            orientationRow
            classname={styles.tile}
          />
          {(getIn(values, 'DifferentToPostalFineholderDetails') === 'true')
          && (
            <div className={gridStyles.gridColFull}>
              <AddressFieldAccessible
                name={pageFields.residentialAddress.formikName}
                title={pageFields.residentialAddress.title}
                manualAddressText="Enter address manually"
                isMandatory
                disabled={isDisabled}
              />
            </div>
          )}
          <Modal close={() => setModal({ ...modal, show: false })} {...modal} />
          <div>
            <button
              type="button"
              style={{ border: 'none', color: '#0072ce', backgroundColor: 'transparent', cursor: 'pointer', marginTop: '5px', textDecoration: 'underline' }}
              onClick={() => {
                  const modalTitle = 'Have you moved recently?';
                  setModal({
                    show: true,
                    title: modalTitle,
                    content: ReviewAddressModal(),
                    contentClass: '',
                  });
                }}>
              Have you moved recently?
            </button>
          </div>
          <Field
            component={ContactInputWithExperian}
            name={pageFields.contactNumber.formikName}
            title="Contact phone number"
            isMandatory
            orientationRow
            obligationNumber={values.OBLIGATION_NUMBER}
            formName={FormType.REVIEW}
            secondaryContact={false}
            hasPrimaryNumberType={false}
            warningMessage="ContactNumberFineholderDetailsMessage"
          />
          <Field
            component={EmailFieldWithExperian}
            name={pageFields.emailAddress.formikName}
            title="Email"
            isMandatory
            orientationRow
            obligationNumber={values.OBLIGATION_NUMBER}
            formName={FormType.REVIEW}
            noEmailField={pageFields.noEmail.formikName}
            currentSP={pageFields.noEmail.title}
            warningMessage="EmailFineholderDetailsMessage"
          />
          <p>I understand that by providing contact details, Fines Victoria may update its records using these details and that the fineholder may be contacted regarding their outstanding fines.</p>
        </div>
      </>
    );
}

export default ReviewStep9;
